export default __webpack_public_path__ + "static/media/02.78d8dd9d.jpg";